import { useEffect, useRef } from "react";

import { tactile } from "./tactile";

/**
 * Пульс результата (FE-14).
 *
 * Экран купленного робота открывается ради одной цифры — сколько он принёс.
 * Одиночный импульс при её появлении даёт знак результата раньше, чем глаз
 * дочитает цвет: мягкий на прибыли, жёсткий на просадке. Это не отклик на
 * действие и не исход операции — приложению нечего подтверждать, оно
 * сообщает о состоянии дел.
 *
 * Срабатывает ровно один раз за жизнь экрана: повтор на каждом обновлении
 * данных превратил бы состояние в навязчивость.
 *
 * @param sign знак результата из `moneySign()`; `undefined`, пока данных нет.
 * Ноль отклика не даёт — праздновать и сочувствовать там нечему.
 */
export function useResultPulse(sign: number | undefined): void {
  const fired = useRef(false);

  useEffect(() => {
    if (fired.current || sign === undefined || sign === 0) return;
    fired.current = true;
    tactile(sign > 0 ? "gain" : "drawdown");
  }, [sign]);
}
